import React from "react";
import DocumentUploadField from "../elements/document-upload-field";

export default function Affidavits(props: any) {
  return (
    <DocumentUploadField
      title="Affidavits to prove trusteeship where beneficiaries are minors. (Optional)"
      onUploaded={props.setAffidavits}
    />
  );
}
